export const AgeCategory = {
  DIGITAL_YOUTH: 1,
  ADULT: 2,
} as const

export type AgeCategoryValue = (typeof AgeCategory)[keyof typeof AgeCategory]

export interface ApiAgeVerificationStartParam {
  ageCategory: AgeCategoryValue
}

export interface ApiAgeVerificationStartPayload {
  sessionId?: string
  verificationUrl?: string
  deadline?: string // ISO 8601形式
  alreadyVerified?: boolean
}

export const VerificationStatus = {
  PENDING: 0,
  EXPIRED: 1,
  VERIFIED: 2,
} as const

export type VerificationStatusValue =
  (typeof VerificationStatus)[keyof typeof VerificationStatus]

export interface ApiAgeVerificationStatusParam {
  ageCategory: AgeCategoryValue
}

export interface ApiAgeVerificationStatusPayload {
  verificationStatus: VerificationStatusValue
  deadline?: string // RFC3339
}
